/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var StarHalfIcon20Solid = forwardRef('StarHalfIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 1.132a.925.925 0 0 0-.861.567l-2.03 4.713L2 6.886c-.819.076-1.15 1.095-.532 1.638l3.856 3.387-1.129 5.006c-.18.802.686 1.432 1.394 1.012L10 15.31V1.132Z" })));
});
